import { Helmet } from 'react-helmet';

import {
    About,
    Contacts,
    Education,
    Experience,
    Landing,
    Navbar,
    Projects,
    Skills
} from '../../components';
import { headerData } from '../../data/headerData';

function HomePage() {
  return (
    <div className="home-content">
      <Helmet>
        <title>{headerData.name} - Porfolio</title>
      </Helmet>

      <Navbar />
      <Landing />
      <About />
      <Experience />
      <Skills />
      <Education />
      <Projects />
      <Contacts />
    </div>
  );
}

export default HomePage;
